import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { EntityApiService } from "../../../../shared/store/entity-store/entity-api.service";
import { Ligne } from "../../models/ligne.model";
import { StatsLigne } from "../../models/stats-ligne.model";
import { environment } from "../../../../../environments/environment";
import { LigneParam } from "../../../ligne-param/models/ligne-param.model";
import { safeFirstValueFrom } from "../../../../shared/utils/safe-first-value-from";

@Injectable({ providedIn: "root" })
export class LignesApiService implements EntityApiService<Ligne> {
  loadOne(id: string): Observable<Ligne> {
    return this.httpClient.get<Ligne>(`${environment.api()}/lignes/id/${id}`);
  }

  httpClient = inject(HttpClient);

  create(entity: Ligne): Observable<Ligne> {
    return this.httpClient.post<Ligne>(`${environment.api()}/lignes`, entity);
  }

  remove(id: string): Observable<string> {
    throw new Error("Method not implemented.");
  }

  update(entity: Ligne): Observable<Ligne> {
    return this.httpClient.post<Ligne>(`${environment.api()}/lignes`, entity);
  }

  loadAll(): Observable<Ligne[]> {
    return this.httpClient
      .get<Ligne[]>(`${environment.api()}/lignes/eager`)
      .pipe(
        map((lignes) =>
          lignes.sort((a, b) => a.denomination.localeCompare(b.denomination)),
        ),
      );
  }

  async saveParamLigne(param: LigneParam) {
    return await safeFirstValueFrom(
      this.httpClient.post<Ligne>(`${environment.api()}/ligne_param`, param),
    );
  }

  async deleteParamLigne(a: LigneParam) {
    return await safeFirstValueFrom(
      this.httpClient.delete<Ligne>(
        `${environment.api()}/ligne_param/id/${a.id}`,
      ),
    );
  }

  stats(payload: {
    ligneId: string;
    dateDebut: Date;
    dateFin: Date;
  }): Observable<StatsLigne> {
    return this.httpClient.post<StatsLigne>(
      `${environment.api()}/stats/ligne`,
      payload,
    );
  }
}
